const NoEncontrada = () => {
  return (
    <>
      <h1>Error 404 ... Lo siento, vuelve al inicio</h1>
    </>
  );
};

export default NoEncontrada;
